export const FALLBACK_VALUE = '-'
